import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 14v7","key":"svg-1"}],["path",{"d":"M7 18h10","key":"svg-2"}]]

/**
 * IconGenderFemme
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ2VuZGVyLWZlbW1lIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDlhNSA1IDAgMSAwIDEwIDBhNSA1IDAgMSAwIC0xMCAwIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNHY3IiAvPgogIDxwYXRoIGQ9Ik03IDE4aDEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/gender-femme
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGenderFemme = createReactComponent('outline', 'gender-femme', 'GenderFemme', __iconNode);

export default IconGenderFemme;